export const quantityBtn = {
	init: function(quantityBtnContainer) {
		if (!quantityBtnContainer) return;
		[].slice.call(quantityBtnContainer).forEach(function(quantityBtn) {
			this.quantityInput = quantityBtn.querySelector('.product-price-section__quantity-input');
			this.quantityMinusBtn = quantityBtn.querySelector('.product-price-section__quantity-btn--minus');
			this.quantityPlusBtn = quantityBtn.querySelector('.product-price-section__quantity-btn--plus');
			this.recalculateBtn = quantityBtn.querySelector('[data-btn="recalculate"]');
			this.currentVal = parseInt(this.quantityInput.value);
			this.assignEventListeners(this.quantityInput, this.recalculateBtn, this.currentVal);
		}.bind(this));
	},
	assignEventListeners: function(input, recbtn, currentVal) {
		this.quantityPlusBtn.addEventListener('click', _=> {
			this.adding(input, recbtn, currentVal);
		});

		this.quantityMinusBtn.addEventListener('click', _=> {
			this.substract(input, recbtn, currentVal);
		});

		this.quantityInput.addEventListener('input', _=> {
			this.inputChange(input, recbtn, currentVal);
		});
	},
	adding: function(input, recbtn, currentVal) {
			let quantityVal = parseInt(input.value);
			quantityVal += 1;
			input.value = quantityVal;
			if (recbtn) {
				this.showRecalculateBtn(recbtn, quantityVal, currentVal)
			}
	},
	substract: function(input, recbtn, currentVal) {
			let quantityVal = parseInt(input.value);
			if (quantityVal <= 1) return;
			quantityVal -= 1;
			input.value = quantityVal;
			if (recbtn) {
				this.showRecalculateBtn(recbtn, quantityVal, currentVal)
			}
	},
	inputChange: function(input, recbtn, currentVal) {
			let quantityVal = parseInt(input.value);
			if (recbtn) {
				this.showRecalculateBtn(recbtn, quantityVal, currentVal)
			}
	},
	showRecalculateBtn: function(recbtn, quantityVal, currentVal) {
		if (quantityVal !== currentVal) {
			recbtn.classList.add('basket-products__update-button--visible');
		} else {
			recbtn.classList.remove('basket-products__update-button--visible');
		}
	}
}
